/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import * as ResourcesConstants from 'constants/ResourcesConstants'
import { getAuthorizationHeader } from 'utils/Helpers'
import { RequestContentType } from 'utils/Helpers'

const encodeQueryData = function(data) {
  const ret = []
  for (const key in data) {
    const value = data[key]
    ret.push(`${encodeURIComponent(key) }=${ encodeURIComponent(value)}`)
  }
  return ret.join('&')
}

const EndUserTokenAPI = Marty.createStateSource({
  id: 'EndUserTokenAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CUSTOMER_API,

  getEndUserToken(orgId, email, leadId, userId, version) {
    let payload
    if (version === 2) {
      payload = {
        org_id: orgId,
        grant_type: 'sdk',
        client_id: ResourcesConstants.CLIENT_ID,
        redirect_uri: 'http://localhost:3000/'
      }

      if (email != null) {
        Object.assign(payload, { email })
      }

      if (leadId != null) {
        Object.assign(payload, { lead_id: leadId })
      }

      if (userId != null) {
        Object.assign(payload, { user_id: userId })
      }
    } else {
      payload = {
        username: email,
        orgId,
        grant_type: 'end_user',
        client_id: ResourcesConstants.CLIENT_ID,
        redirect_uri: 'http://localhost:3000/'
      }
    }

    return this.post({
      url: '/oauth/token',
      contentType: RequestContentType.X_WWW_FORM,
      body: encodeQueryData(payload)
    })
  }
})

export default EndUserTokenAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/EndUserTokenAPI.js